import { StyleSheet } from 'aphrodite';

/**
 * Common styles shared across automation step renderer components.
 * These styles provide consistent visual appearance for read-only display fields.
 */
export const styleSheet = StyleSheet.create({
	/**
	 * Container for renderer content with standard padding
	 */
	rendererContainer: {
		padding: '12px 0',
	},

	/**
	 * Label for form fields with required indicator support
	 */
	fieldLabel: {
		marginBottom: 4,
		fontSize: 14,
		color: '#4A4A4A',
	},

	/**
	 * Standard field display container
	 */
	field: {
		padding: '12px',
		border: '1px solid #E5E7EB',
		borderRadius: 6,
		backgroundColor: '#FFFFFF',
		color: '#374151',
		fontSize: 13,
		minHeight: 40,
		display: 'flex',
		alignItems: 'center',
	},

	/**
	 * Read-only field variant with gray background
	 */
	fieldReadOnly: {
		backgroundColor: '#F9FAFB',
	},

	/**
	 * Placeholder text style for empty fields
	 */
	placeholder: {
		color: '#9CA3AF',
	},

	/**
	 * Info box for displaying schedule information
	 */
	infoBox: {
		marginBottom: 12,
		padding: '8px 12px',
		backgroundColor: '#F3F4F6',
		borderRadius: 6,
		fontSize: 12,
		color: '#374151',
	},

	/**
	 * Info box with blue background for highlighted information
	 */
	infoBoxBlue: {
		backgroundColor: '#EFF6FF',
		color: '#1E40AF',
	},

	/**
	 * Info box with yellow background for warnings
	 */
	infoBoxYellow: {
		backgroundColor: '#FEF3C7',
		color: '#92400E',
	},

	/**
	 * Checkbox/option display with checkmark
	 */
	optionDisplay: {
		fontSize: 12,
		color: '#6B7280',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},

	/**
	 * Field with margin bottom for spacing
	 */
	fieldWithMargin: {
		marginBottom: 12,
	},
});

/**
 * Export individual styles for convenience
 */
export const {
	rendererContainer,
	fieldLabel,
	field,
	fieldReadOnly,
	placeholder,
	infoBox,
	infoBoxBlue,
	infoBoxYellow,
	optionDisplay,
	fieldWithMargin,
} = styleSheet;
